import React from 'react';
import styles from './List.css';
import Row from './Row';
import Pagination from '../../../Pagination';

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedPointActivityId: null };
  }

  render() {
    const { pointActivities } = this.props;
    if (!pointActivities) {
      return null;
    }

    const views = pointActivities.content.map(pointActivity => {
      return (
        <Row
          key={pointActivity.row_id}
          onClickRow={this._onClickRow}
          pointActivity={pointActivity}
          isSelected={
            this.state.selectedPointActivityId ===
            pointActivity.parent_payment_id
          }
        />
      );
    });

    return (
      <div className={styles['length-wrapper']}>
        <div className={styles.wrapper}>
          <table className={styles['table-header']}>
            <thead>
              <tr>
                <th className={styles.date}>Date</th>
                <th className={styles.outlet}>Outlet</th>
                <th className={styles.sale}>Sale</th>
                <th className={styles.point}>Point</th>
              </tr>
            </thead>
          </table>
          <div className={styles['table-content-wrapper']}>
            <table className={styles['table-content']}>
              <tbody>{views}</tbody>
            </table>
          </div>
        </div>
        <Pagination
          className="pull-right"
          numPages={pointActivities.total_pages}
          currentPage={pointActivities.number + 1}
          onPageItemClick={this._onSelectPageNumber}
        />
      </div>
    );
  }

  _onSelectPageNumber = eventKey => {
    this.props.getPointActivity({
      page: eventKey,
      size: 12,
      sort: 'createdAt,desc',
      customerId: this.props.customerDetail.id,
    });
    this.setState({ selectedPointActivityId: '' });
  };

  _onClickRow = (paymentType, paymentId) => {
    this.props.openReceipt({
      payment_type: paymentType,
      parent_payment_id: paymentId,
    });
    this.setState({ selectedPointActivityId: paymentId });
  };
}

export default List;
